import React from 'react';
import SectionIncomingConsignment from '../SectionIncomingConsignment';

const ECOMInwardConsignment = () => (
  <SectionIncomingConsignment
    sectionName="ECOM"
    sectionDisplayName="ECOM Section"
    backRoute="/sections/ecom"
  />
);

export default ECOMInwardConsignment;
